import { createContext, useContext } from "react";

export const GymContext = createContext(null);

export const useGym = () => {
  return useContext(GymContext);
};
